//freshdesk
    setTimeout(()=>{
      (function (d, w, c) { if(!d.getElementById("spd-busns-spt"))
          { var n = d.getElementsByTagName('script')[0], s = d.createElement('script');
           var loaded = false; s.id = "spd-busns-spt"; s.async = "defer"; s.setAttribute("data-self-init", "false");
           s.setAttribute("data-init-type", "opt"); s.src = 'https://cdn.freshbots.ai/assets/share/js/freshbots.min.js';
           s.setAttribute("data-client", "c62e08e4b2781e45b308e0472ad38d95d26d8694");
           s.setAttribute("data-bot-hash", "122a5a41e06215978bb2bc01eada20817ba15fba");
           s.setAttribute("data-env", "prod"); s.setAttribute("data-region", "us");
           if (c) { s.onreadystatechange = s.onload = function ()
           { if (!loaded) { c(); } loaded = true; }; } n.parentNode.insertBefore(s, n); } })
            (document, window, function () { Freshbots.initiateWidget({ autoInitChat: false, getClientParams: function ()
            { return {"cstmr::eml":"","cstmr::phn":"","cstmr::nm":""}; } }, function(successResponse) { }, function(errorResponse) { }); });

 
 //tune     

    !function(){var o=window.tdl=window.tdl||[];if(o.invoked)window.console&&console.error&&console.error("Tune snippet has been included more than once.");
    else{o.invoked=!0,o.methods=["init","identify","convert"],o.factory=function(n){return function(){var e=Array.prototype.slice.call(arguments);
    return e.unshift(n),o.push(e),o}};for(var e=0;e<o.methods.length;e++)
    {var n=o.methods[e];o[n]=o.factory(n)}o.init=function(e)
    {var n=document.createElement("script");
     n.type="text/javascript",n.async=!0,n.src="https://js.go2sdk.com/v2/tune.js";
     var t=document.getElementsByTagName("script")[0];
     t.parentNode.insertBefore(n,t),o.domain=e}}}();
    tdl.init("https://tracking.comfortclick.eu")
    tdl.identify()
    },6000);

//referrer policy script

    document.referrerPolicy = "strict-origin-when-cross-origin";

